import './index.css'

import React from 'react'

import Button from 'components/ui/button'

type Props = {
  title: string
  description: React.ReactNode
  learnMoreUrl?: string
  ctaHref?: string
  ctaLabel?: string
}

const MagicWandIcon = (): React.ReactElement => (
  <svg
    aria-hidden="true"
    className="SubscriptionAddOnCard_BadgeIcon"
    viewBox="0 0 12 12"
  >
    <path
      d="m2.1 9.9 5.3-5.3.5.5-5.3 5.3-.5-.5Zm5.2-7.8.35.8.8.35-.8.35-.35.8-.35-.8-.8-.35.8-.35.35-.8Zm2.3 2.3.45 1 .95.4-.95.45-.45.95-.4-.95-.95-.45.95-.4.4-1ZM4.4.7l.3.65.65.3-.65.3-.3.65-.3-.65-.65-.3.65-.3.3-.65Z"
      fill="currentColor"
    />
  </svg>
)

const PlusIcon = (): React.ReactElement => (
  <svg
    aria-hidden="true"
    className="SubscriptionAddOnCard_PlusIcon"
    viewBox="0 0 16 16"
  >
    <path d="M8 2.5v11M2.5 8h11" fill="none" stroke="currentColor" />
  </svg>
)

/**
 * Reusable card for add-ons promoted from the manage-subscription page.
 */
const SubscriptionAddOnCard = ({
  title,
  description,
  learnMoreUrl,
  ctaHref,
  ctaLabel = 'Add to plan',
}: Props): React.ReactElement => (
  <article className="SubscriptionAddOnCard">
    <div className="SubscriptionAddOnCard_Content">
      <div className="SubscriptionAddOnCard_TitleRow">
        <h3 className="SubscriptionAddOnCard_Title">{title}</h3>
        <span className="SubscriptionAddOnCard_Badge">
          <MagicWandIcon />
          Add on
        </span>
      </div>
      <p className="SubscriptionAddOnCard_Description">{description}</p>
    </div>

    <div className="SubscriptionAddOnCard_Divider" />

    <div className="SubscriptionAddOnCard_Actions">
      {learnMoreUrl ? (
        <a
          className="SubscriptionAddOnCard_LearnMore"
          href={learnMoreUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </a>
      ) : (
        <span
          aria-disabled="true"
          className="SubscriptionAddOnCard_LearnMore SubscriptionAddOnCard_LearnMore--Disabled"
        >
          Learn more
        </span>
      )}

      <Button
        appearance="black"
        caption={ctaLabel}
        className="SubscriptionAddOnCard_Cta"
        dataTestId="subscription-addon-cta"
        disabled={!ctaHref}
        iconNode={<PlusIcon />}
        link={ctaHref}
        linkTarget="_blank"
      />
    </div>
  </article>
)

export default SubscriptionAddOnCard
